import type { TranslationMessages } from '../types';

export const cost_categories: TranslationMessages = {
  title: 'Cost Categories',
  subtitle: 'Manage cost categories for better organization',
  new_category: 'Add Category',
  search_placeholder: 'Search categories...',
  no_results: 'No categories found',
  try_adjusting_search: 'Try adjusting your search criteria',
  add_first_category: 'Add First Category',
  created: 'Created',
  default: 'Default',
  custom: 'Custom',
  filter_categories: 'Filter Categories',
  default_status: 'Default Status',
  select_default_status: 'Select default status',
  all_categories: 'All Categories',
  default_categories: 'Default Categories',
  custom_categories: 'Custom Categories',
  clear_all: 'Clear All',
  apply_filters: 'Apply Filters',
  no_permission_delete: 'You do not have permission to delete cost categories.',
  delete_confirm: 'Are you sure you want to delete this category?',
  delete_confirm_irreversible:
    'Are you sure you want to delete this category? This action cannot be undone.',
  delete_error: 'Could not delete category. Please try again.',
  create_title: 'Create Cost Category',
  create_subtitle: 'Add a new cost category for better organization',
  edit_title: 'Edit Cost Category',
  edit_subtitle: 'Update category information',
  basic_information: 'Basic Information',
  name_placeholder: 'Enter category name...',
  name_required: 'Name is required',
  description_placeholder: 'Enter category description...',
  description_required: 'Description is required',
  parent_placeholder: 'Enter parent category (optional)...',
  set_as_default: 'Set as Default Category',
  summary: 'Summary',
  not_entered: 'Not entered',
  none: 'None',
  yes: 'Yes',
  no: 'No',
  save_category: 'Save Category',
  update_category: 'Update Category',
  delete_category: 'Delete Category',
  no_permission_create: 'You do not have permission to create cost categories.',
  no_permission_edit: 'You do not have permission to edit cost categories.',
  create_error: 'Could not create cost category. Please try again.',
  update_error: 'Could not update cost category. Please try again.',
  load_error: 'Could not load category data. Please try again.',
  categoryCreated: 'Cost category created successfully',
};
